import React from "react";
import "./TermsOfServices.css";
// import { Link } from "react-router-dom";
//import svg from src/assets/icons as link
// import HandSvg from "../../../../src/assets/icons/hand-right.svg";
import HandSvg from "../../../assets/icons/hand-right.svg";
import {  Card } from "antd";
// const { Link } = Typography;

const TermsOfServices = () => {
  return (
    <Card className="tos-card">
      <div className="tos-page-layout">
        <div>
          <h2 className="tos-heading">Terms of Service</h2>
        </div>

        <p>Last update: August 2021</p>
        <>
          <p>Welcome to SkillGigs</p>

          <p>
            SkillGigs is an AI sourcing platform that places the best tech and
            healthcare talent within an innovative talent marketplace designed
            to help you make smarter, faster hiring decisions. SkillGigs builds
            relationships with top talent, and then helps this talent market
            themselves in our marketplace to top employers.
          </p>
          <p>
            The documents linked below are collectively referred to as the
            “Terms of service.” Use of this website constitutes acknowledgment
            and acceptance of the terms of service.​​
          </p>
        </>

        <p className="subheading">Agreement for site users</p>

        <a href="https://new.skillgigs.com/site-agreement-and-service-policy">
          <p className="link-text">
            {" "}
            <img
              src={HandSvg}
              alt="Agreement for site users"
              className="handIcon"
              // style={{paddingLeft:"0.5rem"}}
            />
            Site agreement and service policy{" "}
          </p>
        </a>
        <p className="subheading">All site visitors</p>
        <a href="https://new.skillgigs.com/privacy-policy/">
          <p className="link-text privacy-policy">
            {" "}
            <img src={HandSvg} alt="Privacy policy" className="handIcon" />
            Privacy policy{" "}
          </p>
        </a>


        <a href="https://new.skillgigs.com/privacy-policy/cookie-policy/">
          <p className="link-text cookie-policy">
            {" "}
            <img src={HandSvg} alt="Cookie policy" className="handIcon" />
            Cookie policy{" "}
          </p>
        </a>
      </div>
    </Card>
  );
};

export default TermsOfServices;
